import { testimonials } from '@/mocks/comics';

export default function Testimonials() {
  return (
    <section id="testimonials" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-700">
            <i className="ri-voiceprint-line" />
            用户口碑
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">百万读者的追更之选</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            来自通勤党、学生党与资深漫友的真实阅读体验，咪咕漫画网手机版陪你度过每个碎片时光。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <img
                  src={t.avatar}
                  alt={`${t.name} 的用户头像`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-foreground-950">{t.name}</span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] font-medium text-secondary-800">
                      {t.tag}
                    </span>
                  </div>
                  <p className="mt-0.5 truncate text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}